module.exports = __webpack_public_path__ + "static/media/HQ18_nutrients@3x.c24181ce.png";